import React, { useState } from 'react';
import { Typography } from 'views/components/atoms/Typography';
import { Button } from 'views/components/atoms/Button';
import styled from '@emotion/styled';
import { Color, MAX_WIDTH, Radius } from 'views/constants';
import { Avatar } from 'views/components/molecules/Avatar';
import { FormattedMessage } from 'react-intl';
import { localeIds } from 'locals';

const Wrapper = styled.div`
  max-width: ${MAX_WIDTH};
  margin: auto;
  background-color: ${Color.C6};
  border-radius: ${Radius.DEFAULT};
`;

const ContentsWrapper = styled.div`
  padding: 16px 24px;

  > :first-of-type {
    margin-bottom: 8px;
  }
`;

const StyledTextArea = styled.textarea`
  resize: none;
  width: 100%;
  box-sizing: border-box;
  border: solid 1px ${Color.C14};
  border-radius: ${Radius.DEFAULT};

  &::-webkit-input-placeholder {
    color: ${Color.C14};
  }
`;

const FooterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ButtonWrapper = styled.div`
  width: 130px;
`;

interface CommentModalProps {
  iconSrc: string;
  name: string;
  replyName?: string;
  onSubmit(comment: string): void;
  onCancel(): void;
}

export const CommentModal: React.FC<CommentModalProps> = ({
  iconSrc,
  name,
  replyName,
  onSubmit,
  onCancel,
}) => {
  const [text, setText] = useState('');
  const handleOnChange = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ): void => {
    setText(event.target.value);
  };

  return (
    <Wrapper>
      <ContentsWrapper>
        <Avatar
          src={iconSrc}
          name={name}
          label={
            <Typography bold color={Color.C2}>
              {name}
            </Typography>
          }
        />
        {replyName ? (
          <FormattedMessage
            id={localeIds.commentModal.placeholder.withReplyName}
            values={{ name: replyName }}
          >
            {(placeholderText: string): React.ReactElement => (
              <StyledTextArea
                rows={8}
                placeholder={placeholderText}
                onChange={handleOnChange}
              />
            )}
          </FormattedMessage>
        ) : (
          <FormattedMessage id={localeIds.commentModal.placeholder.defult}>
            {(placeholderText: string): React.ReactElement => (
              <StyledTextArea
                rows={8}
                placeholder={placeholderText}
                onChange={handleOnChange}
              />
            )}
          </FormattedMessage>
        )}
        <FooterWrapper>
          <ButtonWrapper>
            <Button type="button" style="secondary" onClick={onCancel}>
              <FormattedMessage id={localeIds.commentModal.cancel} />
            </Button>
          </ButtonWrapper>
          <ButtonWrapper>
            <Button
              type="submit"
              style="primary"
              onClick={(): void => {
                onSubmit(text);
              }}
              disabled={text === ''}
            >
              <FormattedMessage id={localeIds.commentModal.submit} />
            </Button>
          </ButtonWrapper>
        </FooterWrapper>
      </ContentsWrapper>
    </Wrapper>
  );
};
